export default {
  'pages.layouts.userLayout.title': '欢迎使用数据管理系统',

  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '请输入用户名！',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '请输入密码！',
  'pages.login.success': '登录成功！',

  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',

  'pages.option.title': '操作',
  'pages.option.create': '新建',
  'pages.option.import': '导入',
  'pages.option.edit': '编辑',
  'pages.option.delete': '删除',
  'pages.option.disable': '禁用',
  'pages.option.enable': '启用',
  'pages.option.checkAll': '全选',

  'pages.common.minuteSyncOne': '(每5分钟同步一次)',

  'pages.admin.title': '管理员列表',
  'pages.admin.fields.id': 'id',
  'pages.admin.fields.username': '用户名',
  'pages.admin.fields.password': '密码',
  'pages.admin.fields.nickname': '昵称',
  'pages.admin.fields.avatar': '头像',
  'pages.admin.fields.email': '邮箱',
  'pages.admin.fields.mobile': '电话',
  'pages.admin.fields.roleId': '角色',
  'pages.admin.fields.customerId': '客户',
  'pages.admin.fields.status': '状态',
  'pages.admin.fields.status.0': '禁用',
  'pages.admin.fields.status.1': '启用',
  'pages.admin.fields.lastLoginTime': '最后登录',
  'pages.admin.fields.createdAt': '创建时间',
  'pages.admin.fields.updatedAt': '更新时间',
  'pages.admin.option.create': '新建管理员',
  'pages.admin.option.edit': '编辑管理员',
  'pages.admin.option.delete': '删除管理员',

  'pages.role.title': '角色列表',
  'pages.role.fields.id': 'id',
  'pages.role.fields.name': '英文名',
  'pages.role.fields.title': '中文名',
  'pages.role.fields.permission': '权限',
  'pages.role.fields.createdAt': '创建时间',
  'pages.role.fields.updatedAt': '更新时间',
  'pages.role.option.create': '创建角色列表',
  'pages.role.option.edit': '编辑',
  'pages.role.option.delete': '删除',
  'pages.role.option.allocatePermission': '分配权限',

  // 合作方页面
  'pages.customer.title': '客户列表',
  'pages.customer.fields.id': 'ID',
  'pages.customer.fields.appId': '应用ID',
  'pages.customer.fields.name': '名称',
  'pages.customer.fields.appSecurity': '应用密钥',
  'pages.customer.fields.status': '状态',
  'pages.customer.fields.status.0': '禁用',
  'pages.customer.fields.status.1': '启用',
  'pages.customer.fields.createTime': '创建时间',
  'pages.customer.fields.updateTime': '更新时间',
  'pages.customer.option.create': '新建客户',
  'pages.customer.option.edit': '编辑客户',
  'pages.customer.option.delete': '删除客户',

  // 客户搜索配额页面
  'pages.customerSearchQuotas.title': '客户搜索配额列表',
  'pages.customerSearchQuotas.fields.id': 'ID',
  'pages.customerSearchQuotas.fields.customerName': '客户',
  'pages.customerSearchQuotas.fields.totalQuota': '总配额',
  'pages.customerSearchQuotas.fields.addQuota': '增加配额',
  'pages.customerSearchQuotas.fields.remainingQuota': '剩余配额',
  'pages.customerSearchQuotas.fields.usedQuota': '已用配额',
  'pages.customerSearchQuotas.fields.status': '状态',
  'pages.customerSearchQuotas.fields.status.0': '禁用',
  'pages.customerSearchQuotas.fields.status.1': '启用',
  'pages.customerSearchQuotas.fields.syncTime': '同步时间',
  'pages.customerSearchQuotas.fields.createTime': '创建时间',
  'pages.customerSearchQuotas.fields.updateTime': '更新时间',
  'pages.customerSearchQuotas.option.create': '新建客户搜索配额',
  'pages.customerSearchQuotas.option.edit': '编辑客户搜索配额',
  'pages.customerSearchQuotas.option.delete': '删除客户搜索配额',

  // 客户搜索记录页面
  'pages.customerSearchRecord.title': '客户搜索记录列表',
  'pages.customerSearchRecord.fields.id': 'ID',
  'pages.customerSearchRecord.fields.customerName': '客户',
  'pages.customerSearchRecord.fields.requestId': '请求ID',
  'pages.customerSearchRecord.fields.success': '成功',
  'pages.customerSearchRecord.fields.success.0': '否',
  'pages.customerSearchRecord.fields.success.1': '是',
  'pages.customerSearchRecord.fields.code': '状态码',
  'pages.customerSearchRecord.fields.msg': '消息',
  'pages.customerSearchRecord.fields.costMs': '耗时(毫秒)',
  'pages.customerSearchRecord.fields.syncStatus': '同步状态',
  'pages.customerSearchRecord.fields.syncStatus.0': '未同步',
  'pages.customerSearchRecord.fields.syncStatus.1': '同步',
  'pages.customerSearchRecord.fields.createTime': '创建时间',

  // 客户搜索日记录页面
  'pages.customerSearchDayRecord.title': '客户搜索日记录列表',
  'pages.customerSearchDayRecord.fields.id': 'ID',
  'pages.customerSearchDayRecord.fields.customerName': '客户',
  'pages.customerSearchDayRecord.fields.statDate': '统计日期',
  'pages.customerSearchDayRecord.fields.totalCount': '总次数',
  'pages.customerSearchDayRecord.fields.successCount': '成功次数',
  'pages.customerSearchDayRecord.fields.failCount': '失败次数',
  'pages.customerSearchDayRecord.fields.syncTime': '同步时间',

  // 客户搜索月记录页面
  'pages.customerSearchMonthRecord.title': '客户搜索月记录列表',
  'pages.customerSearchMonthRecord.fields.id': 'ID',
  'pages.customerSearchMonthRecord.fields.customerName': '客户',
  'pages.customerSearchMonthRecord.fields.statMonth': '统计月份',
  'pages.customerSearchMonthRecord.fields.totalCount': '总次数',
  'pages.customerSearchMonthRecord.fields.successCount': '成功次数',
  'pages.customerSearchMonthRecord.fields.failCount': '失败次数',
  'pages.customerSearchMonthRecord.fields.syncTime': '同步时间',

  // 有车搜索配额页面
  'pages.carSearchQuotas.title': '有车搜索配额列表',
  'pages.carSearchQuotas.fields.id': 'ID',
  'pages.carSearchQuotas.fields.customerName': '客户',
  'pages.carSearchQuotas.fields.totalQuota': '总配额',
  'pages.carSearchQuotas.fields.addQuota': '增加配额',
  'pages.carSearchQuotas.fields.remainingQuota': '剩余配额',
  'pages.carSearchQuotas.fields.usedQuota': '已用配额',
  'pages.carSearchQuotas.fields.createTime': '创建时间',
  'pages.carSearchQuotas.option.create': '新建有车搜索配额',
  'pages.carSearchQuotas.option.edit': '编辑有车搜索配额',
  'pages.carSearchQuotas.option.delete': '删除有车搜索配额',

  // 有车搜索日记录页面
  'pages.carSearchDayRecord.title': '有车搜索日记录列表',
  'pages.carSearchDayRecord.fields.id': 'ID',
  'pages.carSearchDayRecord.fields.customerName': '客户',
  'pages.carSearchDayRecord.fields.statDate': '统计日期',
  'pages.carSearchDayRecord.fields.totalCount': '总次数',
  'pages.carSearchDayRecord.fields.successCount': '成功次数',
  'pages.carSearchDayRecord.fields.failCount': '失败次数',
  'pages.carSearchDayRecord.fields.syncTime': '同步时间',

  // 有车搜索月记录页面
  'pages.carSearchMonthRecord.title': '有车搜索月记录列表',
  'pages.carSearchMonthRecord.fields.id': 'ID',
  'pages.carSearchMonthRecord.fields.customerName': '客户',
  'pages.carSearchMonthRecord.fields.statMonth': '统计月份',
  'pages.carSearchMonthRecord.fields.totalCount': '总次数',
  'pages.carSearchMonthRecord.fields.successCount': '成功次数',
  'pages.carSearchMonthRecord.fields.failCount': '失败次数',
  'pages.carSearchMonthRecord.fields.syncTime': '同步时间',

  // 号段页面
  'pages.phoneSegment.title': '号码归属地',
  'pages.phoneSegment.fields.id': 'ID',
  'pages.phoneSegment.fields.phone': '手机号',
  'pages.phoneSegment.fields.pref': '号段前缀',
  'pages.phoneSegment.fields.city': '城市',
  'pages.phoneSegment.fields.province': '省份',
  'pages.phoneSegment.fields.isp': '运营商',
  'pages.phoneSegment.fields.ispType': '运营商类型',
  'pages.phoneSegment.fields.postCode': '邮编',
  'pages.phoneSegment.fields.cityCode': '区号',
  'pages.phoneSegment.fields.areaCode': '行政区划编码',
  'pages.phoneSegment.fields.createTime': '创建时间',
  'pages.phoneSegment.fields.updateTime': '更新时间',
  'pages.phoneSegment.option.create': '新建归属地',
  'pages.phoneSegment.option.edit': '编辑归属地',
  'pages.phoneSegment.option.delete': '删除归属地',

  // 车贷项目
  // 入库列表页面
  'pages.carLoan.warehousing.title': '入库列表',
  'pages.carLoan.warehousing.fields.id': 'ID',
  'pages.carLoan.warehousing.fields.carLoanSource': '数据源',
  'pages.carLoan.warehousing.fields.carTagSource': '车标签来源',
  'pages.carLoan.warehousing.fields.carTagSource.0': 'PP停车',
  'pages.carLoan.warehousing.fields.carTagSource.1': '捷停车',
  'pages.carLoan.warehousing.fields.province': '省份',
  'pages.carLoan.warehousing.fields.city': '城市',
  'pages.carLoan.warehousing.fields.customerName': '客户',
  'pages.carLoan.warehousing.fields.packageId': '包ID',
  'pages.carLoan.warehousing.fields.totalCount': '总次数/完成次数',
  'pages.carLoan.warehousing.fields.finishedCount': '完成次数',
  'pages.carLoan.warehousing.fields.length': '入库总量',
  'pages.carLoan.warehousing.fields.carCount': '有车总量',
  'pages.carLoan.warehousing.fields.md5Dir': 'MD5目录',
  'pages.carLoan.warehousing.fields.file': 'csv 文件',
  'pages.carLoan.warehousing.fields.phoneDir': '号段目录',
  'pages.carLoan.warehousing.fields.status': '状态',
  'pages.carLoan.warehousing.fields.status.0': '上传中',
  'pages.carLoan.warehousing.fields.status.1': '上传完成',
  'pages.carLoan.warehousing.fields.status.2': '验证中',
  'pages.carLoan.warehousing.fields.status.3': '验证完成',
  'pages.carLoan.warehousing.fields.dataStart': '筛选后开始位置',
  'pages.carLoan.warehousing.fields.dataLength': '获取数量',
  'pages.carLoan.warehousing.fields.createTime': '创建时间',
  'pages.carLoan.warehousing.fields.updateTime': '更新时间',
  'pages.carLoan.warehousing.option.filter': '数据筛选',
  'pages.carLoan.warehousing.option.create': '新建入库任务',

  // 分发任务列表页面
  'pages.carLoan.distributeTasks.title': '分发任务列表',
  'pages.carLoan.distributeTasks.fields.id': 'ID',
  'pages.carLoan.distributeTasks.fields.dataSourceId': '数据源ID',
  'pages.carLoan.distributeTasks.fields.province': '省份',
  'pages.carLoan.distributeTasks.fields.city': '城市',
  'pages.carLoan.distributeTasks.fields.carTagSource': '车标签来源',
  'pages.carLoan.distributeTasks.fields.carTagSource.0': 'PP停车',
  'pages.carLoan.distributeTasks.fields.carTagSource.1': '捷停车',
  'pages.carLoan.distributeTasks.fields.status': '状态',
  'pages.carLoan.distributeTasks.fields.status.0': '未筛选',
  'pages.carLoan.distributeTasks.fields.status.1': '筛选中',
  'pages.carLoan.distributeTasks.fields.status.2': '筛选完成',
  'pages.carLoan.distributeTasks.fields.status.3': '筛选失败',
  'pages.carLoan.distributeTasks.fields.length': '总量',
  'pages.carLoan.distributeTasks.fields.dataLength': '获取数量',
  'pages.carLoan.distributeTasks.fields.dataStart': '开始位置',
  'pages.carLoan.distributeTasks.fields.phoneDir': '号段目录',
  'pages.carLoan.distributeTasks.fields.path': '存储路径',
  'pages.carLoan.distributeTasks.fields.createTime': '创建时间',
  'pages.carLoan.distributeTasks.fields.updateTime': '更新时间',

  // 有车验证日统计页面
  'pages.carLoan.carLoanVerifyStatistics.title': '有车验证日统计',
  'pages.carLoan.carLoanVerifyStatistics.fields.id': 'ID',
  'pages.carLoan.carLoanVerifyStatistics.fields.timeoutCount': '超时次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.totalCount': '总次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.actualRequest': '实际请求次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.noActualRequestCount': '无实际请求次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.unknownActualRequestCount': '未知实际请求次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.pptcCacheCount': 'PPTC 缓存次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.jtcCacheCount': 'JTC 缓存次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.cacheNoFoundCount': '缓存未命中次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.circuitBreakerCount': '断路器次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.cacheUnknownCount': '未知缓存次数',
  'pages.carLoan.carLoanVerifyStatistics.fields.statisticDate': '统计日期',
  'pages.carLoan.carLoanVerifyStatistics.fields.createTime': '创建时间',
  'pages.carLoan.carLoanVerifyStatistics.fields.updateTime': '更新时间',
}
